import { Avatar, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, makeStyles } from '@material-ui/core';
import { AccountBalance, CalendarToday, Close, Code, Email, FileCopy, Fingerprint, FlipToBackRounded, Money, OpenInNew, Star, ThumbUp, TransferWithinAStation, Visibility } from '@material-ui/icons';
import moment from 'moment';
import MUIDataTable from 'mui-datatables';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import * as Toastr from "toastr";
import _ from "underscore";
import { getTransactionUrl } from '../../helpers/utility';
import { fetchWithdrawRequest, updateWithdrawRequest } from '../../store/transaction/transaction.actions';
import { getWithdrawRequests } from '../../store/transaction/transaction.selector';
import Loader from '../base/loader';
import TitleBar from '../base/TitleBar';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
}));

export default function WithdrawContainer() {
    const dispatch = useDispatch();
    const classes = useStyles();
    const [selectedItem, setSelecteItem] = useState({});
    const [open, setOpen] = useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [page, setPage] = useState(null);
    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        dispatch(fetchWithdrawRequest({
            page: 0,
            pageSize: 10
        }))
    }, [])

    const { withdraws, isLoading, totalWithdraws } = useSelector((state) => {
        return {
            withdraws: getWithdrawRequests(state),
            totalWithdraws: state.TransactionReducer.totalWithdraws,
            isLoading: state.TransactionReducer.isLoading
        }
    }, []);

    useEffect(() => {
        if (selectedItem._id) {
            const cuItem = _.find(withdraws, x => x._id === selectedItem._id);
            if (cuItem) {
                setSelecteItem(cuItem)
            }
        }
    }, [withdraws])

    const actionRenderer = () => {
        return ({
            name: 'id',
            label: 'Action',
            options: {
                filter: false,
                customBodyRender: (value) => {
                    let dep = _.find(withdraws, x => x._id === value);
                    return (
                        <Visibility
                            className={classes.icon}
                            color="secondary"
                            onClick={() => {
                                setOpen(true);
                                setSelecteItem(dep);
                            }}
                        />
                    );
                }
            }
        });
    };


    const columns = [
        {
            name: 'createdAt',
            label: 'Transaction Date',
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: 'createdBy',
            label: 'User',
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: 'coinType',
            label: 'Withdraw Mode',
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: 'coins',
            label: 'Coins',
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: 'status',
            label: 'Status',
            options: {
                filter: true,
                sort: true,
            }
        },
        actionRenderer()
    ];

    const datum = withdraws.map((item) => {
        return {
            id: item._id,
            createdBy: item.createdBy,
            createdAt: moment(item.createdAt).format("DD-MM-YYYY"),
            coins: (item.method === "USDT" ? item.coins : item.amount) + ' ' + (item.isToken ? item.tokenSymbol : item.coinType),
            tokens: item.transactionTokens + ' ' + item.tokenSymbol,
            transactionCharge: item.transactionCharge + ' ' + item.coinType,
            coinType: item.isToken ? item.tokenSymbol : item.coinType,
            spentHash: item.spentHash,
            receiveHash: item.receiveHash,
            status: item.status,
        };
    });

    const options = {
        selectableRows: false,
        rowsPerPage: rowsPerPage,
        serverSide: true,
        filter: false,
        count: totalWithdraws,
        onChangeRowsPerPage: (numberOfRows) => {
            console.log(numberOfRows, "num");
            setRowsPerPage(numberOfRows);
            dispatch(fetchWithdrawRequest({
                page: page,
                pageSize: numberOfRows
            }));
        },
        onSearchClose: () => {
            setSearchText("");
            dispatch(fetchWithdrawRequest({
                page: page,
                pageSize: rowsPerPage,
                search: ""
            }));
        },
        onTableChange: (action, tableState) => {
            console.log(tableState.page, "table state");
            if (action === "changePage") {
                setPage(tableState.page);
                dispatch(fetchWithdrawRequest({
                    page: tableState.page,
                    pageSize: rowsPerPage,
                    search: searchText
                }));
            } else if (action === "search") {
                setSearchText(tableState.searchText);
                if (tableState.searchText && (tableState.searchText.length > 2 || tableState.searchText.length === 0)) {
                    dispatch(fetchWithdrawRequest({
                        page: page,
                        pageSize: rowsPerPage,
                        search: tableState.searchText
                    }));
                }
            } else {
                console.log(tableState);
            }
        }
    };

    return (
        <div className='m-2 pb-4'>
            {
                isLoading && <Loader />
            }
            <Dialog maxWidth="md" fullWidth open={open} onClose={() => {
                setOpen(false)
            }}>
                <DialogTitle>
                    Withdraw Transaction <Close className='mt-1 float-right' onClick={() => setOpen(false)} />
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <Grid container>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar className='bg-success'><Fingerprint /></Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={selectedItem.referenceNo} secondary={"Reference No"} />
                                <ListItemSecondaryAction>
                                    <FileCopy color="secondary" onClick={() => {
                                        navigator.clipboard.writeText(selectedItem.referenceNo);
                                        Toastr.info("copied to clipboard");
                                    }} />
                                </ListItemSecondaryAction>
                            </ListItem>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar className='bg-success'><TransferWithinAStation /></Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={selectedItem.transactionId} secondary={"Transaction ID"} />
                                <ListItemSecondaryAction>
                                    <FileCopy color="secondary" onClick={() => {
                                        navigator.clipboard.writeText(selectedItem.transactionId);
                                        Toastr.info("copied to clipboard");
                                    }} />
                                </ListItemSecondaryAction>
                            </ListItem>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar className='bg-success'><Money /></Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={selectedItem.amount + " " + (selectedItem.isToken ? selectedItem.tokenSymbol : selectedItem.coinType)} secondary={"Amount"} />
                            </ListItem>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar className='bg-success'><CalendarToday /></Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={moment(selectedItem.createdAt).format("lll")} secondary={"Transaction Date"} />
                            </ListItem>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar className='bg-success'><Email /></Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={selectedItem.userEmail && selectedItem.userEmail} secondary={"Email"} />
                                <ListItemSecondaryAction>
                                    <FileCopy color="secondary" onClick={() => {
                                        navigator.clipboard.writeText(selectedItem.userEmail);
                                        Toastr.info("copied to clipboard");
                                    }} />
                                </ListItemSecondaryAction>
                            </ListItem>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar className='bg-success'><FlipToBackRounded /></Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={selectedItem.createdBy} secondary={"Created By"} />
                            </ListItem>
                        </Grid>
                        {
                            selectedItem.coinType &&
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar className='bg-success'><Code /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText primary={selectedItem.transactionhash} secondary={"Transaction Hash"} />
                                    <ListItemSecondaryAction>
                                        <a target='_blank' href={getTransactionUrl(selectedItem.coinType) + selectedItem.transactionhash}>
                                            <OpenInNew />
                                        </a>
                                    </ListItemSecondaryAction>
                                </ListItem>
                            </Grid>
                        }
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar className='bg-success'><Star /></Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={selectedItem.status} secondary={"Status"} />
                            </ListItem>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    {
                        selectedItem.status === "Initiated" && <Button color='secondary'
                            onClick={() => {
                                Swal.fire({
                                    title: "Approve Withdraw",
                                    text: `Are you sure want to approve the withdraw for amount ${selectedItem.coins} USDT for ${selectedItem.createdBy} ?`,
                                    icon: "question",
                                    showCancelButton: true,
                                    confirmButtonText: "Yes Proceed"
                                }).then((tx) => {
                                    if (tx.isConfirmed) {
                                        dispatch(updateWithdrawRequest(selectedItem._id))
                                    }
                                })
                            }}
                            variant='contained' startIcon={<ThumbUp />}>Approve Withdraw</Button>
                    }
                </DialogActions>
            </Dialog>
            <TitleBar heading="Withdraw Transactions" secondary={""}
                icon={<AccountBalance />} />
            <div className={classes.root}>
                <MUIDataTable
                    title={"Withdraw Transactions List"}
                    data={datum}
                    columns={columns}
                    options={options}
                />
            </div>
        </div >
    );
}

